import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase設定オブジェクト
// 環境変数から設定値を取得
const firebaseConfig = {
    apiKey: "AIzaSyBAYopn2MlgRRH2x5UkM8sYsjjjGuyVGTo",
    authDomain: "strucknazo.firebaseapp.com",
    projectId: "strucknazo",
    storageBucket: "strucknazo.firebasestorage.app",
    messagingSenderId: "548223843744",
    appId: "1:548223843744:web:b62f60177af3726fa678c5",
    measurementId: "G-L9G6WY7PLL"
};

// Firebaseアプリの初期化
const app = initializeApp(firebaseConfig);

// Firebaseサービスを初期化
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analyticsの初期化（ブラウザサポートを確認）
let analytics = null;
isSupported().then(yes => yes ? analytics = getAnalytics(app) : null);

export { analytics };
export default app; 